import { render } from "./SmartProduct.vue?vue&type=template&id=1fb194b1&scoped=true"
import script from "./SmartProduct.vue?vue&type=script&lang=js"
export * from "./SmartProduct.vue?vue&type=script&lang=js"

import "./SmartProduct.vue?vue&type=style&index=0&id=1fb194b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb194b1"]])

export default __exports__